import ApiService from "./api.service";

const AppService = {
  async list() {
    try {
      return await ApiService.get("dealer/apps");
    } catch (error) {
      return error.response || null;
    }
  },

  async accessRequest(data) {
    try {
      return await ApiService.post("user/app/access", data);
    } catch (error) {
      return error.response || null;
    }
  },
};

export { AppService };
